import { EllipsedText, Loading, useMoment, VirtualizedComponent } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo, useRef } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useHover } from 'usehooks-ts';
import { useStyles } from '../../hooks/useStyles';
import { linkState, selectedLinkIdState } from '../../storage/links';

function LinkItem({ data, index, style }: Readonly<ListChildComponentProps<VirtualizedComponent['data']>>) {
  const { overrides } = useStyles();
  const { formatDateFromTs } = useMoment();
  const [selectedLinkId, setSelectedLinkId] = useRecoilState(selectedLinkIdState);
  const linkId = data.items[index];
  const link = useRecoilValue(linkState(linkId));
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const isSelected = selectedLinkId === linkId;

  const onSelectLink = () => {
    if (selectedLinkId === linkId) setSelectedLinkId(undefined);
    else setSelectedLinkId(linkId);
  };

  return (
    <span
      style={style as CSSProperties}
      ref={hoverRef}
    >
      {data.isLoaded(index) ? (
        <ListItem
          overrides={overrides.listItemOverrides({
            onClick: onSelectLink,
            isHover,
            isSelected,
            minHeight: style.height ? +style.height : undefined,
          })}
        >
          <ListItemLabel
            description={
              <span style={{ display: 'flex', flexDirection: 'column' }}>
                <EllipsedText
                  inline
                  breakAll
                >{`Primario: ${link?.assetPrimary.label ?? '-'}`}</EllipsedText>
                <EllipsedText
                  inline
                  breakAll
                >{`Secundario: ${link?.assetSecondary.label ?? '-'}`}</EllipsedText>
              </span>
            }
          >
            <EllipsedText inline>{link?.created ? formatDateFromTs(link.created) : '-'}</EllipsedText>
          </ListItemLabel>
        </ListItem>
      ) : (
        <Loading size="compact" />
      )}
    </span>
  );
}

export default memo(LinkItem);
